"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var _arguments = arguments;
var bindRaf = exports.bindRaf = function bindRaf(fn) {
	var isRunning = null;
	var self = null;
	var args = null;

	var run = function run() {
		isRunning = false;
		fn.apply(self, args);
	};

	return function () {
		self = undefined;
		args = _arguments;

		if (isRunning) {
			return;
		}

		isRunning = true;
		requestAnimationFrame(run);
	};
};


//////////////////
// WEBPACK FOOTER
// ./~/react-on-visible/build/lib/bindRaf.js
// module id = 410
// module chunks = 0